/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { Panel } from 'react-bootstrap';
import subDays from 'date-fns/sub_days';
import addHours from 'date-fns/add_hours';
import addDays from 'date-fns/add_days';
import addMonths from 'date-fns/add_months';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import format from 'date-fns/format';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import LineChart from 'loracoms/LineChart';
import DatePicker from 'loracoms/DatePicker';
import PanelToolbar from 'loracoms/PanelToolbar';
import InlineSelect from 'loracoms/InlineSelect';
import Refresher from 'loracoms/Refresher';
import CollapseToggle from 'loracoms/CollapseToggle';
import { callAPI } from 'lorautils/api';
import IntlMsg from 'lorautils/intl/IntlMsg';

const defaultFrom = () => startOfDay(subDays(new Date(), 1));
const defaultTo = () => endOfDay(new Date());

const propTypes = {
  deviceId: React.PropTypes.string.isRequired,
  intl: React.PropTypes.any.isRequired,
};

class DevicePktsTrend extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, from);
  }

  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.statview');
    this.state = {
      from: defaultFrom(),
      to: defaultTo(),
      by: 'hour',
      series: {
        rxpks: {
          name: this.intlMsg.msg('series.packets'),
          data: [],
          yAxisIndex: 0,
        },
        categories: [],
      },
    };
    this.handleChangeBy = this.handleChangeBy.bind(this);
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  loadData(args = {}) {
    const { from, to, by } = this.state;
    const { by: argBy } = { by, ...args };
    let { to: argTo, from: argFrom } = { from, to, ...args };

    switch (argBy) {
      case 'hour':
        argFrom = format(argFrom, 'YYYYMMDDHH');
        argTo = format(addHours(argTo, 1), 'YYYYMMDDHH');
        break;
      case 'day':
        argFrom = format(argFrom, 'YYYYMMDD');
        argTo = format(addDays(argTo, 1), 'YYYYMMDD');
        break;
      case 'month':
        argFrom = format(argFrom, 'YYYYMM');
        argTo = format(addMonths(argTo, 1), 'YYYYMM');
        break;
      default:
        break;
    }

    this.setState({ reloading: true });

    const { deviceId } = this.props;
    callAPI({
      endpoint: `/lora/nodes/${deviceId}/stats?from=${argFrom}&to=${argTo}`,
    }).then((data) => {
      const list = data.list;
      const rxpks = [];
      const slots = [];

      const formatSlot = (slot) => {
        const s = String(slot);
        switch (argBy) {
          case 'hour':
            return `${s.slice(4, 6)}-${s.slice(6, 8)} ${s.slice(8, 10)}:00`;
          case 'day':
            return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
          case 'month':
            return `${s.slice(0, 4)}-${s.slice(4, 6)}`;
          default:
            return s;
        }
      };

      list.forEach((l) => {
        slots.push(formatSlot(l.slot));
        rxpks.push(l.rxpkt);
      });

      const { series } = this.state;
      series.rxpks.data = rxpks;
      series.categories = slots;
      this.setState({
        series,
        reloading: false,
      });
    }).catch(() => {});
  }

  handleChangeBy(by) {
    this.setState({ by });
    this.loadData({ by });
  }

  handleChangeFrom(from) {
    const to = endOfDay(from);
    this.setState({ from, to });
    this.loadData({ from, to });
  }

  handleChangeTo(to) {
    this.setState({ to });
    this.loadData({ to });
  }

  renderToolbar() {
    const { from, to, by } = this.state;
    const fromDatePicker = (
      <DatePicker date={from} onSelect={this.handleChangeFrom} />
    );
    const toDatePicker = (
      <DatePicker
        date={to}
        onSelect={this.handleChangeTo}
        disabled={d => DevicePktsTrend.handleDisableDate(d, from)}
      />
    );
    const timeBy = (
      <InlineSelect
        values={[by]}
        options={[{
          label: this.intlMsg.msg('button.hour'),
          value: 'hour',
          active: true,
        }, {
          label: this.intlMsg.msg('button.day'),
          value: 'day',
        }]}
        bsStyle="aisz-primary"
        onChange={selected => this.handleChangeBy(selected[0])}
      />
    );

    return <PanelToolbar tools={[fromDatePicker, toDatePicker, timeBy]} />;
  }

  render() {
    const {
      reloading,
      expanded = true,
      resize = 0,
      series,
    } = this.state;

    const header = (
      <div>
        {this.intlMsg.msg('devicestatus')}
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.loadData}
              reloading={reloading}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={expanded}
              onChange={v => this.setState({ expanded: v })}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
        collapsible
        expanded={expanded}
        onEntered={() => this.setState({ resize: Math.random() })}
      >
        {this.renderToolbar()}
        <LineChart
          yAxis={[{
            name: this.intlMsg.msg('series.packets'),
            splitNumber: 5,
          }]}
          xAxis={{
            axisTick: {
              alignWithLabel: true,
            },
            boundaryGap: true,
          }}
          series={[series.rxpks]}
          categories={series.categories}
          dataZoom={[{
            type: 'slider',
            fillerColor: 'rgba(228, 241, 254, 0.4)',
            dataBackground: {
              lineStyle: {
                width: 0,
              },
              areaStyle: {
                color: 'rgba(107, 185, 240, 0.8)',
              },
            },
          }]}
          grid={{
            left: 60,
            top: 30,
            right: 30,
            bottom: 60,
          }}
          resize={resize}
        />
      </Panel>
    );
  }
}

DevicePktsTrend.propTypes = propTypes;

export default injectIntl(DevicePktsTrend);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DevicePktsTrend/index.jsx